import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import UserForm from '@/components/User/UserForm.vue';
import { useRoute, useRouter } from 'vue-router';
import { inject, ref } from 'vue';
import { useUserStore } from '@/store/user';
import User from '@/types/interfaces/User';
import useAppMixin from '@/mixins/appMixin';
import localStorage from '@/utils/localStorage';
import { CAP_PASSWORD, DEFAULT_PAGINATION_PAGE, LOCALSTORAGE_KEYS, PAGINATION_TABLES_NAMES, PROVIDE_KEYS } from '@/utils/constants';
import Permission from '@/types/interfaces/Permission';
import isEqual from 'lodash/isEqual';
import md5 from 'md5';
import { ApiBodyResponseException } from '@/backend/Api';
import ApiBodyResponseStatus from '@/types/AppApiResponseStatus';
import useTablePaginationMixin from '@/mixins/tablePaginationMixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleUser',
  setup(__props) {

const { setPageTitle } = useAppMixin();
const { handleUpdatePage } = useTablePaginationMixin();

const { showSnackbar }: any = inject(PROVIDE_KEYS.SNACKBAR);

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const inProcess = ref(false);
const userId = route.params.userId;
const modeEdit = userId != undefined;
const existedUser = ref({} as User);
const showForm = ref(false);

const loadUser = async () => {
  await userStore
    .fetchUser(Number(userId))
    .then(
      (user: User) => {
        existedUser.value = user;
        showForm.value = true;
      },
      () => {
        router.back();
      }
    )
    .catch(() => {
      router.back();
    });
};

if (modeEdit) {
  setPageTitle('PageTitle.Users.Edit');
  loadUser();
} else {
  setPageTitle('PageTitle.Users.Create');
  showForm.value = true;
}

function onSubmitUserForm(data: any) {
  if (data.formData.permissions.length == 0) {
    showSnackbar('ErrorMessage.User.Permissions.Empty');
    return false;
  }

  inProcess.value = true;
  const authUserData = localStorage.getObject(LOCALSTORAGE_KEYS.AUTORIZED_USER);
  if (modeEdit) {
    const updUser: User = {
      id: existedUser.value?.id,
      organizationId: authUserData.orgId
    };
    if (existedUser.value?.firstName != data.formData.firstName) {
      updUser.firstName = data.formData.firstName;
    }
    if (existedUser.value?.lastName != data.formData.lastName) {
      updUser.lastName = data.formData.lastName;
    }
    if (existedUser.value?.email != data.formData.email) {
      updUser.email = data.formData.email;
    }
    if (data.formData.password != CAP_PASSWORD) {
      updUser.password = md5(data.formData.password);
    }
    if (existedUser.value?.status != data.formData.status) {
      updUser.status = data.formData.status;
    }

    let sortedExistedPermissions = existedUser.value?.permissions
      ?.map((permission: Permission | number) => (permission as Permission).id)
      .sort();
    let sortedCurrentPermissions = data.formData.permissions.sort();
    if (!isEqual(sortedExistedPermissions, sortedCurrentPermissions)) {
      updUser.permissions = data.formData.permissions;
    }
    userStore
      .updateUser(updUser)
      .then(() => {
        router.back();
        showSnackbar('ResponseMessage.User.Update.Success');
      })
      .catch((error) => {        
        if (error instanceof ApiBodyResponseException && (error as ApiBodyResponseException).metadata?.data?.responseStatus == ApiBodyResponseStatus.DUPLICATE_ROW) {
          showSnackbar('ResponseMessage.User.Create.AlreadyExist');
        } else {
          showSnackbar('ResponseMessage.User.Update.Error');
        }
      })
      .finally(() => (inProcess.value = false));
  } else {
    const user: User = {
      firstName: data.formData.firstName,
      lastName: data.formData.lastName,
      email: data.formData.email,
      password: md5(data.formData.password),
      permissions: data.formData.permissions
    };
    userStore
      .createUser(user)
      .then(() => {
        handleUpdatePage(PAGINATION_TABLES_NAMES.USERS, DEFAULT_PAGINATION_PAGE);
        router.back();
        showSnackbar('ResponseMessage.User.Create.Success');
      })
      .catch((error) => {
        if (error instanceof ApiBodyResponseException) {
          showSnackbar('ResponseMessage.User.Create.AlreadyExist');
        } else {
          showSnackbar('ResponseMessage.User.Create.Error');
        }
      })
      .finally(() => (inProcess.value = false));
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      (showForm.value)
        ? (_openBlock(), _createBlock(UserForm, {
            key: 0,
            inProcess: inProcess.value,
            formData: existedUser.value,
            edit: modeEdit,
            onSubmitForm: onSubmitUserForm
          }, null, 8, ["inProcess", "formData"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})